var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c(
          "fragment",
          [
            _c("skp-breadcrumbs", {
              on: {
                "page-title": function(val) {
                  return (_vm.pageTitle = val)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [
          _vm._v("\n            " + _vm._s(_vm.pageTitle) + "\n            "),
          _c("em", { staticClass: "ico_info" }, [
            _c("i", { staticClass: "tooltip fl_btm" }, [
              _vm._v(_vm._s(_vm.$t("MESSAGE.DATA.INACTIVE.ANSWER")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "srchTop_wrap srchQna_wrap pb20" }, [
          _c("article", { staticClass: "srch_basic" }, [
            _c("dl", { staticClass: "dl_search" }, [
              _c("dd", { attrs: { "data-input-type": "select" } }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchType,
                        expression: "searchType"
                      }
                    ],
                    staticClass: "slt_white w100",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.searchType = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.searchTypeList, function(item) {
                      return _c(
                        "option",
                        {
                          key: _vm.pageName + item.code,
                          domProps: { value: item.code }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(item.codeName) +
                              "\n                            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "dd",
                {
                  staticClass: "clearable",
                  attrs: { "data-input-type": "input" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchName,
                        expression: "searchName"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100p",
                    attrs: {
                      type: "text",
                      placeholder: "Enter a user ID or user name"
                    },
                    domProps: { value: _vm.searchName },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        return _vm.onSearch(1)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchName = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("dd", { staticClass: "btn" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_srch",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.onSearch(1)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.SEARCH")) +
                        "\n                        "
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "grid_wrap" },
          [
            _c("div", { staticClass: "grid_total" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.$t("TITLE.TOTAL.COUNT")) + " "
              ),
              _c("em", [_vm._v(_vm._s(_vm.totalCount))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn_wrap" }, [
              _c(
                "a",
                {
                  staticClass: "btn_gray",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.pageMove()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("BUTTON.GOTO.ASNWER.MANAGE")))]
              )
            ]),
            _vm._v(" "),
            _c("toast-grid", {
              key: _vm.gridKey,
              ref: _vm.gridId,
              attrs: {
                gridId: _vm.gridId,
                columns: _vm.columns,
                data: _vm.gridData,
                options: _vm.options,
                isTotalCount: false,
                click: _vm.contentClick
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "paginate" },
              [
                _c("sdl-pagination", {
                  attrs: {
                    align: "center",
                    "current-page": _vm.currentPage,
                    "total-rows": _vm.totalCount,
                    "per-page": _vm.nRecordsPerPage
                  },
                  on: { change: _vm.onSearch }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9619612c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9619612c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/qnaManager/inactiveAnswererList.vue
// module id = N7hn
// module chunks = 0